import script from "./RomanMap.vue?vue&type=script&setup=true&lang=js"
export * from "./RomanMap.vue?vue&type=script&setup=true&lang=js"

import "./RomanMap.vue?vue&type=style&index=0&id=db54f94a&lang=css"

const __exports__ = script;

export default __exports__